import React, { useState, useEffect } from 'react'
import { useFetch } from './useFetch';
import Follower from './Follower'

function App() {
  const { loading, data } = useFetch();
  const [page, setPage] = useState(0);
  const [followers, setFollowers] = useState([]);

  useEffect(() => {
    if (loading) return;
    setFollowers(data[page]);
  }, [loading, page]);

  const handlePageChange = (index) => {
    console.log(index);
    setPage(index);
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const prevPage = () => {
    setPage((oldPage) => {
      let prevPage = oldPage - 1;
      if (prevPage < 0) {
        prevPage = data.length - 1;
      }
      return prevPage;
    });
  };

  const nextPage = () => {
    setPage((oldPage) => {
      let nextPage = oldPage + 1;
      if (nextPage > data.length - 1) {
        nextPage = 0;
      }
      return nextPage;
    });
  };

  return (
    <>
      <main>
        <div className="section-title">
          <h1>{loading ? 'loading...' : 'pagination'}</h1>
          <h2>{loading ? 'Fetching followers...' : 'Github Followers'}</h2>
        </div>
        <section className="followers">
          {loading && <div className="loading"></div>}
          <div className="container">
            {followers.map((follower) => {
              return <Follower key={follower.id} {...follower} />;
            })}
          </div>
          {!loading && data.length > 0 && (
            <div className="btn-container" >
              <button className="prev-btn" onClick={prevPage}>prev</button>
              {data.map((_, index) => {
                return (
                  <button
                    key={index}
                    className={`page-btn ${(index) === page ? 'active-btn' : ''}`}
                    onClick={() => handlePageChange(index)}
                  >
                    {index + 1}
                  </button>
                );
              })}
              <button className="next-btn" onClick={nextPage}>next</button>
            </div>
          )}
        </section>
      </main>
    </>
  );
}

export default App
